import Column from '@components/Column';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';
import { Fragment } from 'react';

function RecommendationItemSkeletons() {
    return (
        <Fragment>
            {Array.from({ length: 5 }).map((_, idx) => (
                <RecommendationItemSkeleton key={`recommendation-${idx}`} />
            ))}
        </Fragment>
    );
}

function RecommendationItemSkeleton() {
    return (
        <Container spacing={2} fullWidth >
            <Skeleton shape='block'
                width={120}
                height={120} />
            <Column fullWidth align='center' spacing={0.5}>
                <Skeleton shape='text' width={100} height={16} />
                <Skeleton shape='text' width={60} height={22} />
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    max-width: 120px;
    min-width: 120px;
`;

export default RecommendationItemSkeletons;
